var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M3 8l4.5 3L12 4l4.5 7L21 8l-2 11H5L3 8zm3 11h12"}})])}
var staticRenderFns = []

export { render, staticRenderFns }